import { 
  SET_PREDEFINED_BP_SPINNER,
  SET_MANUFACTURERS,
  SET_DESIGNATIONS,
  CLEAR_DESIGNATIONS
} from './actions';
  import { mergeDeep } from '@services/helper.service';
  
  const initState = {
    isWaitingPredefinedBP: false,
    manufacturers: [],
    designations: []
  };
  
  const application = (state = initState, action) => {
    switch (action.type) {
      case SET_PREDEFINED_BP_SPINNER: {
        return mergeDeep({}, state, {
          isWaitingPredefinedBP: action.value
        });
      }
      case SET_MANUFACTURERS: {
        return mergeDeep({}, state, {
          manufacturers: action.value
        });
      }
      case SET_DESIGNATIONS: {
        return mergeDeep({}, state, {
          designations: {
            [action.manufacturer]: action.designations
          }
        });
      }
      case CLEAR_DESIGNATIONS: {
        return mergeDeep({}, state, {
          designations: []
        });
      }
      default: {
        return state;
      }
    }
  };

export default application;



// WEBPACK FOOTER //
// ./src/reducers/web-services/application/index.js